import { render, staticRenderFns } from "./bill-of-materials-bulk-update-list.vue?vue&type=template&id=d475ed86"
import script from "./bill-of-materials-bulk-update-list.vue?vue&type=script&lang=js"
export * from "./bill-of-materials-bulk-update-list.vue?vue&type=script&lang=js"
import style0 from "./bill-of-materials-bulk-update-list.vue?vue&type=style&index=0&id=d475ed86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports